import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

export interface RandomizedSite {
  geometry: GeoJSON.Point
  seed: number
  createdAt: string
  samplingAreaId: string
  farmId: string
}

export default async function randomizeV4Generate({
  samplingAreaId,
  samples,
}: {
  samplingAreaId: string
  samples: number
}): Promise<RandomizedSite[]> {
  const response = await apiClient.post(endpoints.v2.randomize.v4Generate, {
    samplingAreaId,
    samples,
  })
  return unwrapCollection<RandomizedSite>(response)
}
